const variables = {
  familyBase: '"Gotham",sans-serif',
  familyHeader: '"DIN Next LT Pro",serif',

  primaryColor: '#c20f2f',
  fontColor: '#404040',
  bgColor: '#ebebeb',
}

export default variables;